class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/default`;
    }
    /**
     * Returns a default bridge (PMI) for the user specified by `accountId`
     * and `extensionId` identifiers.
     *
     * HTTP Method: get
     * Endpoint: /rcvideo/v2/account/{accountId}/extension/{extensionId}/bridges/default
     * Rate Limit Group: Medium
     * App Permission: Video
     */
    async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
export default Index;
